import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawAddContentIcon from "./RawAddContentIcon.svg.jsx";

const AddContentIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawAddContentIcon} {...props} />;
});

export default AddContentIcon;
